
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ApplicationEliot, CorporateEliot } from '~/interfaces/user.interface';

@Component
export default class DescriptionThirdApp extends Vue {
    @Prop({}) readonly app?: CorporateEliot | ApplicationEliot ;
}
